import { useEffect, useRef, type ReactNode } from 'react';
import { Note } from '@/components/ui';

/**
 * خطأُ النموذج حيث ينظر المستخدم: يُعرض قرب زرّ الإرسال، ويُمرَّر إليه ويُركَّز عليه عند ظهوره.
 * (25 سبتمبر 2026) كان الخطأ أعلى نموذجٍ طويل، فعلى الجوال يضغط المستخدم «أنشئ حسابي» في
 * أسفل الصفحة ولا يرى شيئاً — فيظنّ أن الزرّ لا يعمل. يُعاد رسمُه بمفتاحٍ جديد لكل محاولة
 * (`key`) فيُمرَّر إليه ثانيةً ولو تكرّر النصُّ نفسُه.
 */
export function FormError({ title, children }: { title?: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView?.({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    el.focus({ preventScroll: true });
  }, []);
  return (
    <div ref={ref} tabIndex={-1} className="form-error">
      <Note kind="danger" title={title}>{children}</Note>
    </div>
  );
}
